var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { defaultImageProps } from './defaults';
import { DivTag, ImgTag } from '../../Utils/AtomicTag';
// 图片默认SVG
var ImageSrc = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMzIiBoZWlnaHQ9Ijk2IiB2aWV3Qm94PSIwIDAgMTMzIDk2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PHJlY3QgZmlsbC1vcGFjaXR5PSIuMDUiIHdpZHRoPSIxMzMiIGhlaWdodD0iOTYiIHJ4PSIyIi8+PHBhdGggZD0iTTk0IDI0YTQgNCAwIDAgMSA0IDR2NDBhNCA0IDAgMCAxLTQgNEgzOGE0IDQgMCAwIDEtNC00VjI4YTQgNCAwIDAgMSA0LTRoNTZ6TTc4Ljg0NCA0My4zMDdjLTEuMjYtLjY2LTIuOTYtLjM5My0zLjguNTk3TDY1LjgzIDU0Ljc3NmMtLjE4OS4yMjMtLjQzLjQxNi0uNzA4LjU3LTEuMjQuNjgyLTIuOTQ4LjQ0NS0zLjgxNS0uNTNsLTYuMDA0LTYuNzQ2YTIuNjA2IDIuNjA2IDAgMCAwLS44NjQtLjYyNWMtMS4zMDctLjYtMi45ODQtLjI1My0zLjc0Ni43NzVMMzguNDQgNjQuNzU0YTIgMiAwIDAgMCAxLjYwNyAzLjE5SDkzLjE1YTIgMiAwIDAgMCAxLjYxOC0zLjE3NUw3OS43MDIgNDQuMDMxYTIuNDcyIDIuNDcyIDAgMCAwLS44NTgtLjcyNHpNNDkuODc1IDI4LjI1YTUuNjI1IDUuNjI1IDAgMSAwIDAgMTEuMjUgNS42MjUgNS42MjUgMCAwIDAgMC0xMS4yNXoiIGZpbGwtb3BhY2l0eT0iLjEiIGZpbGwtcnVsZT0ibm9uemVybyIvPjwvZz48L3N2Zz4=';
var SkeletonImage = /** @class */ (function (_super) {
    __extends(SkeletonImage, _super);
    function SkeletonImage(props) {
        return _super.call(this, props) || this;
    }
    SkeletonImage.prototype.render = function () {
        var _a = this.props, active = _a.active, rest = __rest(_a, ["active"]);
        var activeClassName = active ? 'active' : '';
        return (React.createElement(DivTag, __assign({ name: SkeletonImage.NAME }, rest),
            React.createElement(ImgTag, { atomics: 'text-base', className: "" + activeClassName, src: ImageSrc })));
    };
    SkeletonImage.defaultImageProps = defaultImageProps;
    SkeletonImage.NAME = 'skeleton-image';
    SkeletonImage.displayName = 'SkeletonImage';
    return SkeletonImage;
}(Component));
export { SkeletonImage };
